import { render, staticRenderFns } from "./BaseTablePagedServerSide.vue?vue&type=template&id=718718ec&"
import script from "./BaseTablePagedServerSide.vue?vue&type=script&lang=js&"
export * from "./BaseTablePagedServerSide.vue?vue&type=script&lang=js&"
import style0 from "./BaseTablePagedServerSide.vue?vue&type=style&index=0&id=718718ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VDivider,VPagination,VRow,VSpacer})
